import React from "react";
import "../styles/main.scss";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Header from "./partials/Header";
import Home from "./pages/Home";
import SiteLoader from "./partials/SiteLoader"

class PersonalWebsite extends React.Component {
  render() {
    return (
      <Router>
        <SiteLoader />
        <div className="page-container">
          <Header />
          <div className="page-content">
            <Route exact path="/">
              <Redirect to="/about-me/" />
            </Route>
            <Route exact path="/about-me">
              <Redirect to="/about-me/" />
            </Route>
            <Route exact path="/about-me/">
              <Home />
            </Route>
          </div>
        </div>
      </Router>
    );
  }
}
export default PersonalWebsite;
